export default (theme) => ({
    root: {
        height: 'calc(70vh)',
        display: 'flex',
        flexDirection: 'column',
    },
    contentContainer: {
        position: 'relative',
        height: '100%',
        overflow: 'hidden',
        '& > div': {
            height: '100%',
        },
    },
    fragmentContainer: {
        height: '100%',
        '& iframe': {
            width: '100%',
            height: '100%',
            border: 'none',
        },
    },
    carouselFullModal: {
        zIndex: 1100,
    },
    loaderOverlay: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: '100%',
        bottom: 0,
        zIndex: 1100,
    },
    loader: {
        position: 'absolute',
        top: 'calc(50% - 15px)',
        left: 'calc(50% - 15px)',
    },
    templateSelect: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0,
    },
    error: {
        height: 200,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
    },
    errorIcon: {
        width: 32,
        height: 32,
        margin: '0 auto 5px',
    },
    errorText: {
        display: 'block',
        color: theme.colors.utility.textSecondary,
        textAlign: 'center',
    },
});
